
export default function Button(theme) {
    return {
        MuiButton: {
            styleOverrides: {
                sizeLarge: {
                    height: 48,
                },
                sizeSmall: {
                    padding: '4px 12px',
                },
                contained: {
                    backgroundColor: theme.palette.primary.darker,
                    color: theme.palette.secondary.lighter,
                    boxShadow: 'none!important',
                    padding: '8px 24px',
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                    },
                },
                outlined: {
                    border: `1px solid ${theme.palette.grey[500_32]}`,
                    color: theme.palette.primary.dark,
                    backgroundColor: 'transparent',
                    padding: '8px 24px',
                    '&:hover': {
                        backgroundColor: theme.palette.primary.darker,
                        color: theme.palette.primary.light,
                    },
                },
                text: {
                    padding: '8px 24px',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
            },
        },
    };
}
